import ProStatus from './ProStatus';

export default ProStatus;
